<script>
	import { getTranslationsList } from '@woltair/translations-package-fe'
	import { sendGTM } from '$lib/analytics'
	import { ACADEMY } from '$lib/routes'
	import { t, tTag } from '$lib/translations'

	export let data
</script>

<section class="page-fullwidth overflow-visible">
	<div class="page-wrapper relative grid md:pb-28 md:pt-12 lg:grid-cols-2">
		<div
			class="absolute -z-0 w-full bg-right-top bg-no-repeat sm:aspect-[3224/1442] sm:bg-[url(/images/misc/cooperation-background.webp)] {data.termsCount >
			0
				? 'lg: bg-[length:50%_auto]'
				: 'bg-[length:auto_100%]'}"
		/>
		<div class="relative lg:min-w-[36rem]">
			<h1>{t('web.cooperation.title')}</h1>
			<p class="mt-8 max-w-md text-base leading-relaxed">
				{t('web.cooperation.titleSubtext')}
			</p>
			<a
				on:click={() => sendGTM('hr_click')}
				href={t('web.cooperation.contacts.formLink')}
				class="btn btn-filled-primary mt-8 whitespace-break-spaces"
			>
				{t('web.cooperation.box.buttonText')}
			</a>
			{#if data.termsCount > 0}
				<a
					href="/{ACADEMY}"
					class="mt-12 block h-fit w-fit max-w-xl rounded-xl border border-neutral-200 bg-white p-8 transition-all hover:shadow-lg"
				>
					<h4 class="unstyled text-1.5xl font-extrabold tracking-normal">
						{t('web.cooperation.academy.title')}
					</h4>
					<p
						class="arrow-before mt-4 flex w-fit items-center gap-4 text-primary-500 transition-all hover:gap-5"
					>
						{t('web.cooperation.academy.terms', { termsCount: data.termsCount })}
					</p>
				</a>
			{/if}
			<img
				class="mt-12-res sm:hidden"
				src="/images/misc/cooperation-background-mobile.webp"
				alt="František Hastrdlo, Woltair Partner"
			/>
		</div>
	</div>
</section>

<section class="page-wrapper relative z-10 pb-28-res">
	<h2
		class="unstyled mt-2-res max-w-2xl text-4.5xl-res font-extrabold leading-tight tracking-tight"
	>
		{t('web.cooperation.section1.suptitle')}
	</h2>

	<ul class="tick-list tick-list--split mt-8 grid !pl-0 text-lg sm:grid-cols-2">
		<li>{t('web.cooperation.section1.title')}</li>
		{#each getTranslationsList('web.cooperation.section1.list', 8) as key}
			<li>{t(key)}</li>
		{/each}
	</ul>
</section>

<!-- eslint-disable svelte/valid-compile -->
<section class="page-wrapper grid pb-28-res md:grid-cols-2">
	<div>
		<h4 class="unstyled text-lg-res font-semibold text-primary-500 md:text-base">
			{t('web.cooperation.section2.suptitle')}
		</h4>
		<h2
			class="unstyled 5xl-res mt-2-res max-w-md text-4.5xl-res font-extrabold leading-tight tracking-tight"
		>
			{t('web.cooperation.section2.title')}
		</h2>

		<ul class="tick-list mt-8 max-w-lg !pl-0 text-lg">
			<li>{t('web.cooperation.section2.list.1')}</li>
			<li>{t('web.cooperation.section2.list.2')}</li>
			<li>{t('web.cooperation.section2.list.3')}</li>
			<li>{t('web.cooperation.section2.list.4')}</li>
			<li>{t('web.cooperation.section2.list.5')}</li>
		</ul>
	</div>
	<div class="mt-12 flex md:mt-0 md:justify-center">
		<div class="grid h-fit max-w-lg gap-6 rounded-2xl bg-white px-6-res py-12-res sm:px-10">
			<h3 class="unstyled mb-4 text-2xl font-extrabold">
				{t('web.cooperation.box.title')}
			</h3>
			<div class="flex items-center gap-4">
				<img src="/images/icons/phone-red.svg" alt="phone" class="mx-1 aspect-square h-5" />

				<div class="phone">
					<a
						href={t('web.cooperation.contacts.phoneRef')}
						class="text-2xl-res font-semibold text-primary-500 sm:text-2xl"
					>
						{t('web.cooperation.contacts.phoneNum')}
					</a>
				</div>
			</div>

			<div class="flex items-center gap-4">
				<img src="/images/icons/email-red.svg" alt="email icon" class="aspect-square h-7" />

				<div class="mail">
					<a
						href="mailto:{tTag('web.cooperation.contacts.email')}"
						class="text-2xl-res font-semibold text-primary-500 sm:text-2xl"
					>
						{t('web.cooperation.contacts.email')}
					</a>
				</div>
			</div>

			<a
				on:click={() => sendGTM('hr_click')}
				href={t('web.cooperation.contacts.formLink')}
				class="btn btn-filled-primary mt-4 whitespace-break-spaces"
			>
				{t('web.cooperation.box.buttonText')}
			</a>
		</div>
		<div />
	</div>
</section>

<style lang="scss">
	.arrow-before::before {
		@apply inline-block aspect-square w-[.75em] content-[''];
		@apply bg-[url(/images/icons/arrow/next-red.svg)] bg-center bg-no-repeat;
	}

	.tick-list {
		li {
			@apply relative flex items-center py-4 pl-[1em] pr-8;

			&::before {
				@apply ml-[-1em] mr-[1em] inline-block aspect-square h-[1em] content-[''];
				@apply bg-[url(/images/icons/tick-circle.svg)] bg-contain bg-center bg-no-repeat;
			}
		}

		&--split li {
			@apply py-8-res;
			@apply border-neutral-200 md:border-b;

			&:last-child,
			&:nth-last-child(2):nth-child(odd) {
				@apply md:border-none;
			}
		}
	}
</style>
